// useDebouncedValue — returns `value` after it has been stable for
// `delay` ms. Used by useSearch to keep the autocomplete from firing
// a network request on every keystroke.

import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState<T>(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])
  return debounced
}
